import customAxios from '@/utils/custom-axios';

const baseApiUrl = `${process.env.VUE_APP_API}/patient/account/unclaimedrecords`;

export const CLINIC_QR_LOOKUP_RESULT = {
  SUCCESS: 1,
  INVALID_TOKEN: 0,
};

export const CLINIC_QR_VERIFY_RESULT = {
  SUCCESS: 1,
  BINDING_FAILED: 0,
  RATE_LIMITED: -1,
};

const formatBirthdateForApi = (date) => {
  if (!date) return '';
  const [mm, dd, yyyy] = date.split('/');
  if (!mm || !dd || !yyyy) return date;
  return `${mm}-${dd}-${yyyy}`;
};

export const ClinicQrClaimService = {
  lookupProfiles: (doctorUserId) => {
    return customAxios.get(`${baseApiUrl}/${encodeURIComponent(doctorUserId)}`);
  },
  verifyProfile: ({doctorUserId, patientId, lastname, birthdate}) => {
    return customAxios.post(
      `${baseApiUrl}/${encodeURIComponent(doctorUserId)}/claimbind`,
      {
        id: patientId,
        lastname,
        birthdate: formatBirthdateForApi(birthdate),
      },
    );
  },
};
